
import { SvgChevronLeft, SvgChevronRight, SvgChevronDown, SvgChevronUp } from "@itwin/itwinui-icons-react";
import styles from "./CollapsedHandle.module.css";

type Position = "left" | "right" | "up" | "down";

interface CollapsedHandleProps {
  position: Position;
  visible: boolean;
  onClick: () => void;
}

export const CollapsedHandle = ({ position, visible, onClick }: CollapsedHandleProps) => {
  return (
    <div
      className={[styles.handle, position === "left" || position === "right" ? styles.handleVertical : styles.handleHorizontal, !visible ? styles.hidden : ""].join(" ")}
      onClick={onClick}
      data-test={`atp-collapsed-handle-${position}`}>
      {position === "left" &&
        <SvgChevronRight className={styles.icon} />}
      {position === "right" &&
        <SvgChevronLeft className={styles.icon} />}
      {position === "up" &&
        <SvgChevronDown className={styles.icon} />}
      {position === "down" &&
        <SvgChevronUp className={styles.icon} />}
    </div>
  );
}